import React, { useEffect } from 'react';
import './Expertise.css';
import html from '../../images/expertise/html.png';
import css from '../../images/expertise/css.png';
import bootstrap from '../../images/expertise/bootstrap.png';
import teilwind from '../../images/expertise/tailwind.png';
import react from '../../images/expertise/react.png';
import github from '../../images/expertise/github.png';
import vercel from '../../images/expertise/vercel.png';
import netlify from '../../images/expertise/netlify.png';
import expressJs from '../../images/expertise/expressJS.png';
import firebase from '../../images/expertise/firebase.png';
import mongoDb from '../../images/expertise/mongodb.png';
import Aos from 'aos';
import 'aos/dist/aos.css';

const Expertise = () => {

    useEffect( () => {
        Aos.init({
            offset: 100,
            duration: 2500
        })
    }, []);

    return (
        <div className='w-11/12 mx-auto mt-10'>

            <div className='flex justify-center items-center'>
            <h2 data-aos='flip-right' className='text-xl mb-5 mt-10 lg:text-4xl font-semibold text-center md:mb-5 border border-blue-600 inline-block rounded rounded-tl-full rounded-br-full px-10 py-2'>Expertise</h2>
            </div>
            <div className='flex flex-col'>
                <div data-aos='flip-right' className='expertise flex items-center border border-blue-600 px-5 py-2 rounded rounded-br-full ml-3'>
                    <img className='w-7 mr-2' src={html} alt="" />
                    <h2 className='text-lg md:text-2xl font-semibold'>HTML5</h2>
                </div>
                <div data-aos='flip-right' className='expertise flex items-center border border-blue-600 px-5 py-2 rounded rounded-br-full ml-3'>
                    <img className='w-7 mr-2' src={css} alt="" />
                    <h2 className='text-lg md:text-2xl font-semibold'>CSS3</h2>
                </div>
                <div data-aos='flip-right' className='expertise flex items-center border border-blue-600 px-5 py-2 rounded rounded-br-full ml-3'>
                    <img className='w-7 mr-2' src={bootstrap} alt="" />
                    <h2 className='text-lg md:text-2xl font-semibold'>Bootstrap5</h2>
                </div>
                <div data-aos='flip-right' className='expertise flex items-center border border-blue-600 px-5 py-2 rounded rounded-br-full ml-3'>
                    <img className='w-7 mr-2' src={teilwind} alt="" />
                    <h2 className='text-lg md:text-2xl font-semibold'>Teilwind CSS</h2>
                </div>
                <div data-aos='flip-right' className='expertise flex items-center border border-blue-600 px-5 py-2 rounded rounded-br-full ml-3'>
                    <img className='w-7 mr-2' src={react} alt="" />
                    <h2 className='text-lg md:text-2xl font-semibold'>React JS</h2>
                </div>
                <div data-aos='flip-right' className='expertise flex items-center border border-blue-600 px-5 py-2 rounded rounded-br-full ml-3'>
                    <img className='w-7 mr-2' src={github} alt="" />
                    <h2 className='text-lg md:text-2xl font-semibold'>GitHub</h2>
                </div>
                <div data-aos='flip-right' className='expertise flex items-center border border-blue-600 px-5 py-2 rounded rounded-br-full ml-3'>
                    <img className='w-7 mr-2' src={vercel} alt="" />
                    <h2 className='text-lg md:text-2xl font-semibold'>Vercel</h2>
                </div>
                <div data-aos='flip-right' className='expertise flex items-center border border-blue-600 px-5 py-2 rounded rounded-br-full ml-3'>
                    <img className='w-7 mr-2' src={netlify} alt="" />
                    <h2 className='text-lg md:text-2xl font-semibold'>Netlify</h2>
                </div>
                <div data-aos='flip-right' className='expertise flex items-center border border-blue-600 px-5 py-2 rounded rounded-br-full ml-3'>
                    <img className='w-7 mr-2' src={expressJs} alt="" />
                    <h2 className='text-lg md:text-2xl font-semibold'>Express JS</h2>
                </div>
                <div data-aos='flip-right' className='expertise flex items-center border border-blue-600 px-5 py-2 rounded rounded-br-full ml-3'>
                    <img className='w-7 mr-2' src={firebase} alt="" />
                    <h2 className='text-lg md:text-2xl font-semibold'>Firebase</h2>
                </div>
                <div data-aos='flip-right' className='expertise flex items-center border border-blue-600 px-5 py-2 rounded rounded-br-full ml-3'>
                    <img className='w-7 mr-2' src={mongoDb} alt="" />
                    <h2 className='text-lg md:text-2xl font-semibold'>MongoDB</h2>
                </div>
            </div>

        </div>
    );
};

export default Expertise;